export enum VetsuiteApi {
  Prismatic = 'https://hooks.prismatic.io/trigger/SW5zdGFuY2VGbG93Q29uZmlnOjk3N2Q3NTFiLWQzYzgtNDc4NC1hNjI0LTgyNzE5YWI1MWI5YQ=='
}
